//src/Components/SideBarNav/clientMenu.tsx
import React from 'react';
import { commonMenu } from './commonMenu';
import NavItem from './NavItem';
import { ManageProjectsIcon, PasswordProfileIcon } from 'assets/icons';

interface ClientMenuProps {
  isTaxExpanded: boolean;
  setIsTaxExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isFinCenExpanded: boolean;
  setIsFinCenExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  handleToggle: (
    setter: React.Dispatch<React.SetStateAction<boolean>>,
  ) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

export default function clientMenuItems(props: ClientMenuProps) {
  return (
    <>
      {commonMenu({
        ...props,
        taxReturnsPath: '/dashboard/questionnaires', // Client-specific path
      })}
    </>
  );
}
